import Cookies from 'universal-cookie';

export const cookies = new Cookies();
export const getLongitude = () => {

    var longitude;
    longitude = cookies.get('longitude');


    if (longitude) {
        return longitude;
    }
    return null;
};



// WEBPACK FOOTER //
// ./src/utils/getLongitude.js